module.exports = __webpack_public_path__ + "img/DZ2010AC.05256342.png";